import { render, staticRenderFns } from "./ReminderEmails.vue?vue&type=template&id=699c0ba1"
import script from "./ReminderEmails.vue?vue&type=script&lang=ts"
export * from "./ReminderEmails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699c0ba1')) {
      api.createRecord('699c0ba1', component.options)
    } else {
      api.reload('699c0ba1', component.options)
    }
    module.hot.accept("./ReminderEmails.vue?vue&type=template&id=699c0ba1", function () {
      api.rerender('699c0ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ReminderEmails.vue"
export default component.exports